import './resources/js/helpers';
import './plugins/popper/popper';
import './plugins/jquery/jquery';
import './resources/js/bootstrap';
import './plugins/perfect-scrollbar/perfect-scrollbar';
import './plugins/hammer/hammer';
import './resources/js/validation';

import './package/datatables/dataTables';

import './plugins/select2/select2';
import './plugins/cleavejs/cleave';
import './plugins/cleavejs/cleave-phone';

import 'boxicons'


window.bootstrap = require('bootstrap');
